/* eslint-disable no-unused-expressions */
import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import PriceListActions, { priceListActionTypes } from '@Actions/inventory/priceListActions';
import PriceListServices from '../../services/inventory/priceListServices';

/**
 * @param action
 */
function* _createPriceList(action) {
  try {
    yield put(PriceListActions.createPriceListLoading(true));
    const priceList = yield PriceListServices.createPriceList(action.payload);
    if (priceList.success) {
      yield put(TrackerActions.trackAction(priceListActionTypes.CREATE_PRICE_LIST.SUCCESS, priceList.data));
      notification.open({
        type: 'success',
        message: 'Price List successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(priceList?.data?.[0]);
      yield put(PriceListActions.createPriceListLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: priceList.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PriceListActions.createPriceListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(PriceListActions.createPriceListLoading(false));
    yield put(TrackerActions.trackAction(priceListActionTypes.CREATE_PRICE_LIST.ERROR, error));
  }
}

/**
 *
 */
function* createPriceList() {
  yield takeLatest(priceListActionTypes.CREATE_PRICE_LIST.REQUEST, _createPriceList);
}

/**
 * @param action
 */
function* _updatePriceList(action) {
  try {
    yield put(PriceListActions.updatePriceListLoading(true));
    const priceList = yield PriceListServices.updatePriceList(action.payload);
    if (priceList.success) {
      yield put(TrackerActions.trackAction(priceListActionTypes.UPDATE_PRICE_LIST.SUCCESS, priceList.data));
      notification.open({
        type: 'success',
        message: 'Price List successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(priceList);
      yield put(PriceListActions.updatePriceListLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: priceList?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(PriceListActions.updatePriceListLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(PriceListActions.updatePriceListLoading(false));
    yield put(TrackerActions.trackAction(priceListActionTypes.UPDATE_PRICE_LIST.ERROR, error));
  }
}

/**
 *
 */
function* updatePriceList() {
  yield takeLatest(priceListActionTypes.UPDATE_PRICE_LIST.REQUEST, _updatePriceList);
}

/**
 * @param action
 */
function* _getApplyPriceLists(action) {
  try {
    PriceListActions.getApplyPriceListsSuccess(null);
    yield put(PriceListActions.getApplyPriceListsLoading(true));
    const {
      tenantId, priceListId, customerId, states, skuId, callback,
    } = action;
    const applyPriceLists = yield PriceListServices.getApplyPriceLists(tenantId, priceListId, customerId, states, skuId);
    yield put(PriceListActions.getApplyPriceListsSuccess(applyPriceLists));
    if (callback) callback(applyPriceLists?.data || []);
    yield put(PriceListActions.getApplyPriceListsLoading(false));
  } catch (error) {
    yield put(PriceListActions.getApplyPriceListsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.GET_APPLY_PRICE_LISTS.ERROR, error));
  }
}

/**
 *
 */
function* getApplyPriceLists() {
  yield takeLatest(priceListActionTypes.GET_APPLY_PRICE_LISTS.REQUEST, _getApplyPriceLists);
}

/**
 * @param action
 */
function* _getPriceLists(action) {
  try {
    PriceListActions.getPriceListsSuccess(null);
    yield put(PriceListActions.getPriceListsLoading(true));
    const {
      tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword,
    } = action;
    const salesOrders = yield PriceListServices.getPriceLists(tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword);
    yield put(PriceListActions.getPriceListsSuccess(salesOrders));
    yield put(PriceListActions.getPriceListsLoading(false));
  } catch (error) {
    yield put(PriceListActions.getPriceListsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.GET_PRICE_LISTS.ERROR, error));
  }
}

/**
 *
 */
function* getPriceLists() {
  yield takeLatest(priceListActionTypes.GET_PRICE_LISTS.REQUEST, _getPriceLists);
}

/**
 * @param action
 */
function* _getPriceListById(action) {
  try {
    yield put(PriceListActions.getPriceListByIdLoading(true));
    const {
      tenantId, priceListId, isListScreen, callback,
    } = action;
    const selectedPriceList = yield PriceListServices.getPriceLists(tenantId, priceListId, isListScreen);
    yield put(PriceListActions.getPriceListByIdSuccess(selectedPriceList?.data?.[0] || {}));
    if (callback) callback(selectedPriceList?.data?.[0] || {});
    yield put(PriceListActions.getPriceListByIdLoading(false));
  } catch (error) {
    yield put(PriceListActions.getPriceListByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.GET_PRICE_LIST_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getPriceListById() {
  yield takeLatest(priceListActionTypes.GET_PRICE_LIST_BY_ID.REQUEST, _getPriceListById);
}

/**
 * @param action
 */
function* _updatePriceListStatus(action) {
  try {
    yield put(PriceListActions.updatePriceListStatusLoading(true));
    const priceList = yield PriceListServices.updatePriceListStatus(action.payload);

    if (priceList.success) {
      notification.open({
        type: 'success',
        message: 'Price List status successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: priceList?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PriceListActions.updatePriceListStatusLoading(false));
  } catch (error) {
    yield put(PriceListActions.updatePriceListStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.UPDATE_STATUS_PRICE_LIST.ERROR, error));
  }
}

/**
 *
 */
function* updatePriceListStatus() {
  yield takeLatest(priceListActionTypes.UPDATE_STATUS_PRICE_LIST.REQUEST, _updatePriceListStatus);
}

/**
 * @param action
 */
function* _deletePriceList(action) {
  try {
    yield put(PriceListActions.deletePriceListLoading(true));
    const priceList = yield PriceListServices.deletePriceList(action.payload);

    if (priceList.success) {
      notification.open({
        type: 'success',
        message: 'Price List successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: priceList?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PriceListActions.deletePriceListLoading(false));
  } catch (error) {
    yield put(PriceListActions.deletePriceListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.DELETE_PRICE_LIST.ERROR, error));
  }
}

/**
 *
 */
function* deletePriceList() {
  yield takeLatest(priceListActionTypes.DELETE_PRICE_LIST.REQUEST, _deletePriceList);
}

/**
 * @param action
 */
function* _getCustomPriceList(action) {
  try {
    yield put(PriceListActions.getCustomPriceListLoading(true));
    const { orgId, sampleType } = action;
    const customPriceList = yield PriceListServices.getCustomPriceList(orgId, sampleType);
    yield put(PriceListActions.getCustomPriceListSuccess(customPriceList));
    if (!customPriceList) {
      notification.open({
        type: 'error',
        message: customPriceList.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = 'price list';
      link.href = URL.createObjectURL(
        new Blob([customPriceList], { type: customPriceList.type }),
      );
      link.click();
    }
    yield put(PriceListActions.getCustomPriceListLoading(false));
  } catch (error) {
    yield put(PriceListActions.getCustomPriceListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.GET_CUSTOM_PRICE_LIST.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getCustomPriceList() {
  yield takeLatest(priceListActionTypes.GET_CUSTOM_PRICE_LIST.REQUEST, _getCustomPriceList);
}

/**
 * @param action
 */
function* _getExistingPriceList(action) {
  try {
    yield put(PriceListActions.getExistingPriceListLoading(true));
    const { orgId, priceListId, includeOtherProducts } = action;
    const existingPriceList = yield PriceListServices.getExistingPriceList(orgId, priceListId, includeOtherProducts);
    yield put(PriceListActions.getExistingPriceListSuccess(existingPriceList));
    if (!existingPriceList) {
      notification.open({
        type: 'error',
        message: existingPriceList.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = 'existing price list';
      link.href = URL.createObjectURL(
        new Blob([existingPriceList], { type: existingPriceList.type }),
      );
      link.click();
    }
    yield put(PriceListActions.getExistingPriceListLoading(false));
  } catch (error) {
    yield put(PriceListActions.getExistingPriceListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(priceListActionTypes.GET_EXISTING_PRICE_LIST.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getExistingPriceList() {
  yield takeLatest(priceListActionTypes.GET_EXISTING_PRICE_LIST.REQUEST, _getExistingPriceList);
}

/**
 *
 */
export default function* priceListSaga() {
  yield all([
    createPriceList(),
    getPriceLists(),
    getApplyPriceLists(),
    updatePriceList(),
    getPriceListById(),
    updatePriceListStatus(),
    deletePriceList(),
    getCustomPriceList(),
    getExistingPriceList(),
  ]);
}
